import React from "react";
import "./ErrorBoundary.css";

/**
 * Route-level error boundary.
 *
 * Catches render/lifecycle errors below it so a crash in one surface shows a
 * friendly reload screen instead of a white page (and, in production, instead
 * of tearing down the whole app).
 *
 * variant="admin" — dark, darkroom-styled full-screen message for the console.
 * variant="guest" — light, clean centered message for guest-facing pages.
 */
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // Log for debugging — visible in the browser console / remote logs.
    console.error(
      `[ErrorBoundary:${this.props.variant || "guest"}] Uncaught render error:`,
      error,
      errorInfo && errorInfo.componentStack
    );
  }

  handleReload = () => {
    window.location.reload();
  };

  render() {
    if (!this.state.hasError) {
      return this.props.children;
    }

    const isAdmin = this.props.variant === "admin";
    return (
      <div
        className={`error-boundary error-boundary--${isAdmin ? "admin" : "guest"}`}
        role="alert"
      >
        <div className="error-boundary__message">
          {isAdmin ? "משהו השתבש בקונסולה" : "משהו השתבש"}
        </div>
        <button
          type="button"
          className="error-boundary__reload"
          onClick={this.handleReload}
        >
          טעינה מחדש
        </button>
      </div>
    );
  }
}

export default ErrorBoundary;
